import { useTicketSalesSellableStore } from '../../../useTicketSalesSellable';
import { calculateSoldPercent } from './helpers';

type TicketSalesSoldPercentCellPropsType = {
  ticketSalesId: string;
  ticketsSold: number;
  ticketsSellable: number;
  noDataPlaceholder: string;
};

export const TicketSalesSoldPercentCell: React.FC<
  TicketSalesSoldPercentCellPropsType
> = ({ ticketSalesId, ticketsSold, ticketsSellable, noDataPlaceholder }) => {
  const sellable = useTicketSalesSellableStore(
    (state) => state.sellable[ticketSalesId] ?? ticketsSellable
  );

  const soldPercent = calculateSoldPercent({ ticketsSold, sellable });

  return soldPercent ?? noDataPlaceholder;
};
